import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/services/data.service';
import { UserService } from '../../service/user.service';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ResponseData } from 'src/app/shared/services/teacher.interface';
import { UserData } from '../../core.interface';

interface RoleOptions{
  value:number,
  label:string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

roleOptions : RoleOptions[] = [
    { value: 1, label: 'I am a student' },
    { value: 2, label: 'I am a teacher' },
  ];
pageFragment: number = 0;
selectedUserRole: number | null = null;
isPasswordVisible: boolean = false;
error = ''
signUpForm: FormGroup;
loginForm: FormGroup;
loginError = '';
signupError = '';
referralCode: string = '';
referralData : referralData;
referralCodeError = '';
userDetails : userDetails;
visible = false;
visible1 = false;
visible2 = false;
open = "assets/icons/open_eye.svg";
close= "assets/icons/close_eye.svg";

  constructor(private fb: FormBuilder,
    private loaderService: LoaderService,
    private router:Router,
    private userService: UserService,
    public serviceData: DataService,) {
    this.signUpForm = this.fb.group({
      name: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: this.passwordMatchValidator });
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.pageFragment = sessionStorage.getItem('lFragment')
    ? Number(sessionStorage.getItem('lFragment')) : 0;
    this.selectedUserRole = sessionStorage.getItem('GCRole')
    ? Number(sessionStorage.getItem('GCRole')) : null;
    this.referralData = sessionStorage.getItem('GCRefer')
    ? JSON.parse(sessionStorage.getItem('GCRefer')) : '';
    // throw new Error('Method not implemented.');
  }

  submitRole(){
    sessionStorage.setItem('GCRole',this.selectedUserRole.toString());
    this.referralCodeError = ''
    this.pageFragment++; //1
    this.savePageFragment(this.pageFragment)
  }

  submitReferralCode() {
    this.referralCodeError = ''
    if (this.referralCode.trim() !== '') {
      this.loaderService.display(true);
      //student - 1, teacher - 2
      let api = Number(sessionStorage.getItem('GCRole')) == 1 
      ? this.serviceData.validateReferal(this.referralCode)
      : this.serviceData.validateTeacherReferal(this.referralCode);
      api.subscribe({
        next:(res:ResponseType<referralData>) =>{
          this.loaderService.display(false);
          this.referralData = res.data
          sessionStorage.setItem('GCRefer',JSON.stringify(this.referralData));
          this.pageFragment++;
          this.savePageFragment(this.pageFragment);
          this.referralCode = '';
          this.referralCodeError = ''
          this.clear()
        },
        error:(err:HttpErrorResponse) =>{
          this.loaderService.display(false);
          console.error(err);
          this.referralCodeError = err.error.detail?.detail;
          this.clear()
        },
      })
    }
  }

  submitSignUpForm(){
    this.signUpForm.markAllAsTouched();
    if (this.signUpForm.valid) {
      this.loaderService.display(true);
      let data : {
        group: string;
        name: string;
        password: string;
        role: number;
      }  = {
        group: this.referralData?.id,
        name:this.signUpForm.controls.name.value,
        password:this.signUpForm.controls.password.value,
        role: this.selectedUserRole,
      }
      //student - 1, teacher - 2
      let api = Number(sessionStorage.getItem('GCRole')) == 1 
      ? this.serviceData.signUP(data)
      : this.serviceData.signUpTeacher(data);
      api.subscribe({
        next:(res:ResponseType<UserData>) =>{
          this.loaderService.display(false);
          this.userService.login(res.data);
          this.userDetails = res.data;
          this.userDetails.password = this.signUpForm.controls.password.value;
          this.signUpForm.reset();
          // this.userService.login(res.data);
          this.clear()
          this.pageFragment++;
          this.savePageFragment(4);
        },
        error:(err:HttpErrorResponse)=>{
          this.loaderService.display(false);
          console.error(err)
          this.signupError = err.error.detail?.detail;
          this.clear()
        }
      })
    }
  }

  submitLoginForm() {
    this.loginError = '';
    this.loginForm.markAllAsTouched();
    if (this.loginForm.valid) {
      this.loaderService.display(true);
      let loginData = {
        "username": this.loginForm.controls.username.value,
        "password": this.loginForm.controls.password.value
      }
      this.serviceData.login(loginData).subscribe({
        next:(res:ResponseType<UserData>) => {
          this.loginForm.reset();
          this.userService.login(res.data);
          sessionStorage.removeItem('lFragment');
          if(res.data.role == 1){
            this.router.navigateByUrl('/map-view')
          }else {
            this.checkTeacherStatus()
          }
          this.loaderService.display(false);
        },
        error:(err:HttpErrorResponse) =>{
          this.loaderService.display(false);
          console.error(err);
          this.loginError = err.error.detail?.detail;
          this.clear()
        },
      })
    }
  }

  checkTeacherStatus(){
    this.loaderService.display(true);
    this.serviceData.getTeacherGroupStatus().subscribe({
      next:(res:ResponseData<TeacherStatus>) =>{
        //if the game still exits the res.data will have an object 
        //otherwise the we get res.data as a empty object
        if(res.data?.status == 102){
          let endTime = Math.floor(Number(res.data.end_time))
          sessionStorage.setItem('end_time',endTime.toString());
          sessionStorage.setItem('GCTeamId',res.data.id);
          this.router.navigateByUrl('/leaderboard')
          this.loaderService.display(false);
        } else if(res.data?.status == 101){
          sessionStorage.setItem('GCTeamId',res.data.id);
          this.router.navigateByUrl('/join-team')
          this.loaderService.display(false);
        }
        else{
          this.router.navigateByUrl('/category')      
          this.loaderService.display(false);
        }
      },
      error:(err) =>{
        console.error(err);
        this.loaderService.display(false);
      },
    })
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  savePageFragment(fragment:number){
    sessionStorage.setItem('lFragment',fragment.toString())
  }

  selectOption(value: number): void {
    this.selectedUserRole = value;
  }

  goToFragment(fragment:number){
    this.pageFragment = fragment
    this.savePageFragment(fragment);
  }

  signUpNavigation(){
    if(this.userService.isUserLoggedIn()){
      let userData : UserData = this.userService.getUserData()
      this.router.navigateByUrl( userData.role == 1 ? '/map-view' : "/category")
    } else {
      this.goToFragment(0);
    }
  }

    // Show Password
    viewPswd() {
      this.visible = !this.visible;
      // this.changetype = !this.changetype;
    }

  goBack(){
    this.pageFragment--;
    this.savePageFragment(this.pageFragment)
    this.clear()
  }

  clear(){
    this.signUpForm.reset()
    this.loginForm.reset()
    this.referralCode = ""
  }

  restrictSpace(event: any , type?:string) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault()
    }
    if(type){
      this.loginError = ''
    }
  }

  restrictSpaceOnPassword(event: any , type?:string) {
    if (event.code === 'Space') {
      event.preventDefault()
    }
    if(type){
      this.loginError = ''
    }
  }

}



export interface ResponseType<T> {
  success : boolean;
  detail : string;
  code : number;
  data : T;
}

export interface referralData {
  id : string;
  name : string;
  image : any;
  description : string;
  code : string;
  is_active : boolean;
}

export interface userDetails {
  token : string;
  id : string;
  name : string;
  username : string;
  password? : string;
}

interface TeacherStatus{
  id: string,
  group_code: string,
  start_time: number,
  end_time: number,
  status: number
}